import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { Translate } from 'react-localize-redux';

/**
 * Renders 'back' and 'next' buttons. It will only render the 'back' btn if this.props.goBack is defined
 * <StepControlButtons> is imported by each "step" where 'goNext' and 'goBack' are defined.
 */

export default class StepControlButtons extends React.Component {
	static propTypes = {
		cancel: PropTypes.func,
		goBack: PropTypes.func,
		goNext: PropTypes.func,
		submit: PropTypes.func,
		submitId: PropTypes.string,
		skip: PropTypes.func,
		remindMeLater: PropTypes.func,
		doNotShowAgain: PropTypes.func,
		nextDisabled: PropTypes.bool,
		backDisabled: PropTypes.bool,
	};

	render() {
		const {
			cancel,
			goBack,
			goNext,
			submit,
			submitId,
			skip,
			remindMeLater,
			doNotShowAgain,
			nextDisabled,
			backDisabled,
		} = this.props;

		return (
			<div>
				{remindMeLater && (
					<Button
						onClick={remindMeLater}
						className="left margin-right-5"
						disabled={backDisabled}>
						<Translate id="remind_me_later" />
					</Button>
				)}
				{doNotShowAgain && (
					<Button
						onClick={doNotShowAgain}
						className="left"
						disabled={backDisabled}>
						<Translate id="do_not_show_me_this_again" />
					</Button>
				)}
				{cancel && (
					<Button
						onClick={cancel}
						className="left"
						disabled={backDisabled}>
						<Translate id="cancel" />
					</Button>
				)}
				{goBack && (
					<Button
						onClick={goBack}
						className="left"
						disabled={backDisabled}>
						<Translate id="back" />
					</Button>
				)}
				{skip && (
					<Button
						type="primary"
						onClick={skip}
						className="right"
						disabled={nextDisabled}>
						<Translate id="skip" />
					</Button>
				)}
				{goNext && (
					<Button
						type="primary"
						onClick={goNext}
						className="right"
						disabled={nextDisabled}>
						<Translate id="next" />
					</Button>
				)}
				{submit && (
					<Button
						type="primary"
						className="right"
						id={submitId}
						onClick={submit}
						disabled={nextDisabled}>
						<Translate id="done" />
					</Button>
				)}
			</div>
		);
	}
}
